import React, { useState } from 'react';

interface FilterOption {
  key: string;
  label: string;
  type?: 'text' | 'select' | 'date';
  options?: { value: string; label: string }[];
}

interface TableFilterProps {
  filters: FilterOption[];
  onFilter: (filterValues: { [key: string]: string }) => void;
}

const TableFilter: React.FC<TableFilterProps> = ({ filters, onFilter }) => {
  const [filterValues, setFilterValues] = useState<{ [key: string]: string }>({});
  const [isExpanded, setIsExpanded] = useState(false);

  const handleChange = (key: string, value: string) => {
    const newValues = { ...filterValues, [key]: value };
    setFilterValues(newValues);
    onFilter(newValues);
  };

  const handleClear = () => {
    setFilterValues({});
    onFilter({});
  };

  return (
    <div style={{ marginBottom: '20px', background: 'var(--bg-card)', padding: '15px', borderRadius: '8px', border: '1px solid var(--border-color)' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: isExpanded ? '15px' : '0' }}>
        <h4 style={{ margin: 0, fontSize: '1rem', color: 'var(--text-main)', display: 'flex', alignItems: 'center', gap: '8px' }}>
          🔍 Filtros
          {Object.keys(filterValues).length > 0 && (
            <span className="badge badge-info" style={{ fontSize: '0.7rem' }}>
              {Object.keys(filterValues).length} ativo(s)
            </span>
          )}
        </h4>
        <div style={{ display: 'flex', gap: '10px' }}>
          {Object.keys(filterValues).length > 0 && (
            <button
              onClick={handleClear}
              style={{ background: 'none', border: 'none', color: 'var(--danger)', cursor: 'pointer', fontSize: '0.9rem', textDecoration: 'underline' }}
            >
              Limpar
            </button>
          )}
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            style={{ background: 'none', border: 'none', color: 'var(--primary-blue)', cursor: 'pointer', fontSize: '1.2rem' }}
          >
            {isExpanded ? '▲' : '▼'}
          </button>
        </div>
      </div>

      {isExpanded && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '15px' }}>
          {filters.map((filter) => (
            <div key={filter.key} className="form-group" style={{ marginBottom: 0 }}>
              <label style={{ fontSize: '0.85rem', marginBottom: '5px' }}>{filter.label}</label>
              {filter.type === 'select' ? (
                <select
                  value={filterValues[filter.key] || ''}
                  onChange={(e) => handleChange(filter.key, e.target.value)}
                  style={{ padding: '8px', fontSize: '0.9rem', backgroundColor: 'var(--bg-card)', color: 'var(--text-main)', border: '1px solid var(--border-color)', borderRadius: '4px' }}
                >
                  <option value="">Todos</option>
                  {filter.options?.map((opt) => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
              ) : filter.type === 'date' ? (
                <input
                  type="date"
                  value={filterValues[filter.key] || ''}
                  onChange={(e) => handleChange(filter.key, e.target.value)}
                  style={{ padding: '8px', fontSize: '0.9rem', backgroundColor: 'var(--bg-card)', color: 'var(--text-main)', border: '1px solid var(--border-color)', borderRadius: '4px' }}
                />
              ) : (
                <input
                  type="text"
                  value={filterValues[filter.key] || ''}
                  onChange={(e) => handleChange(filter.key, e.target.value)}
                  placeholder={`Buscar por ${filter.label.toLowerCase()}...`}
                  style={{ padding: '8px', fontSize: '0.9rem', backgroundColor: 'var(--bg-card)', color: 'var(--text-main)', border: '1px solid var(--border-color)', borderRadius: '4px' }}
                />
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TableFilter;
